import React, { useEffect, useMemo, useState } from "react";
import { TablePagination } from "@mui/material";

/**
 * Paging for lists the API returns in one go (design item 16).
 * const { pageRows, pager } = useClientPaging(rows);
 * Render pageRows in the table and {pager} under it. Goes back to page 1 when
 * the list changes length (new filter or search).
 */
export default function useClientPaging(rows, initialRowsPerPage = 25) {
  const list = Array.isArray(rows) ? rows : [];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);

  useEffect(() => {
    setPage(0);
  }, [list.length]);

  const pageRows = useMemo(
    () => list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [list, page, rowsPerPage]
  );

  const pager = list.length > 10 ? (
    <TablePagination
      component="div"
      count={list.length}
      page={Math.min(page, Math.max(0, Math.ceil(list.length / rowsPerPage) - 1))}
      onPageChange={(_, p) => setPage(p)}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={(e) => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setPage(0);
      }}
      rowsPerPageOptions={[10, 25, 50, 100]}
      sx={{ borderTop: "1px solid #E5E7EB" }}
    />
  ) : null;

  return { pageRows, pager, page, rowsPerPage };
}
